module.exports = __webpack_public_path__ + "img/gaku_text_09.f8ca2ff4.png";